<template>
<div>
  <div class="container-fluid p-0">
    <div class="row g-0">
      <div class="col-xl-7">
        <div class="auth-full-bg pt-lg-5 p-4">
          <div class="w-100">
            <div class="bg-overlay"></div>
          </div>
        </div>
      </div>
      <!-- end col -->

      <div class="col-xl-5">
        <div class="auth-full-page-content p-md-5 p-4">
          <div class="w-100">
            <div class="d-flex flex-column h-100">
              <div class="mb-4 mb-md-5">
                <router-link to="/" class="d-block auth-logo">
                  <img src="@/assets/images/KikkomanNameLogo.png" alt height="35" />
                </router-link>
              </div>
              <div class="my-auto">
                <slot />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</div>
</template>

<script>
export default {
name: "AuthLayer"
}
</script>

<style scoped>

</style>
